import { render, staticRenderFns } from "./AddEditProject.vue?vue&type=template&id=a9ec2afc&scoped=true&"
import script from "./AddEditProject.vue?vue&type=script&lang=js&"
export * from "./AddEditProject.vue?vue&type=script&lang=js&"
import style0 from "./AddEditProject.vue?vue&type=style&index=0&id=a9ec2afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ec2afc",
  null
  
)

export default component.exports